import { Tab } from 'entities/Tab/interfaces';
import { SET_TABS, SET_TAB, DELETE_TAB } from './constants';

export const setTabs = (tabs: Tab[]) => ({
  type: SET_TABS,
  payload: tabs,
});

export const setTab = (tab: Tab) => ({
  type: SET_TAB,
  payload: tab,
});

export const deleteTab = (id: string) => ({
  type: DELETE_TAB,
  payload: id,
});

export type Actions = ReturnType<typeof setTabs> | ReturnType<typeof setTab> | ReturnType<typeof deleteTab>;
